import api from '../../plugins/api';

const getDealCars = (params) => {
  return api.get('/api/crm/deals/getDealCars', params);
};

export default getDealCars;
